<template>
  <div class="cart-order-block cart-order-block_receiving">
    <div class="cart-order-block__head">
      <div class="cart-order-block__number-wrap">
        <div class="cart-order-block__number">
          2 / 3
        </div>
      </div>
      <h3 class="cart-order-block__title text__subtitle">
        Способ получения
      </h3>
    </div>

    <div class="cart-order-block__content form-field">
      <div class="cart-order-block__field">
        <label for="order_address" class="cart-order-block__label">
          Адрес доставки
        </label>
        <input
            type="text"
            id="order_address"
            name="address"
            class="cart-order-block__input"
            placeholder="Город, улица, дом, квартира"
            maxlength="255"
            autocomplete="street-address"
            v-model="address"
        >
        <ItemErrors :errors="errors.addressFilled"/>
        <ItemErrors :errors="errors.address"/>
      </div>

      <div class="cart-order-block__address-hint text text__small">
        Менеджер подберёт транспортную компанию, рассчитает стоимость доставки и свяжется с вами.
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import ItemErrors from "./ItemErrors.vue";

// Способ получения «по адресу»: службу доставки и способ отправки выбирает менеджер.
// Прежний выбор ТК / ПВЗ / курьера — TheCartOrderReceiving.vue (заморожен, не подключён).
export default {
  name: "TheCartOrderReceivingAddress",
  components: {
    ItemErrors,
  },
  computed: {
    address: {
      get () {
        return this.$store.state.order.address;
      },
      set (value) {
        this.$store.commit('order/setAddress', value);
      }
    },
    ...mapState('order', {
      'errors': 'errors',
    }),
  },
}
</script>
